import {
  DashboardOutlined,
  ReconciliationOutlined,
  ContainerOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
export const sideBarMenuItemsList = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardOutlined,
    protected: true,
    subItems: [],
  },
  {
    path: "/dashboard/contracts",
    name: "Contract Management",
    icon: ReconciliationOutlined,
    protected: true,
    subItems: [],
  },
  // {
  //   path: "/dashboard/mycontract",
  //   name: "MY Contract",
  //   icon: ContainerOutlined,
  //   protected: true,
  //   subItems: [],
  // },
  {
    path: "/dashboard/organisations",
    name: "Organisations",
    icon: ContainerOutlined,
    protected: true,
    subItems: [],
  },
  {
    path: "/dashboard/csv",
    name: "CSV",
    icon: DownloadOutlined,
    protected: true,
    subItems: [],
  },
];
